export class DeleteNewsletterRequest {
  constructor(
    public id: number,
    public regions: string[],
    public includeIntranetTemplates: boolean
  ) {}
}
